<!-- clonado de components/V2/ResourceScroller.MovieBox pero no adaptado totalmente para pictures. damn deadline-->
<template>
    <article
            :class="{placeholder: placeholder}"
            class="picture"
            @click="handleClickOnPost"
    >
        <template v-if="model /*&& model.webstar*/">
          <div
              class="img locked"
              :style="cssVars"
          >
            <router-link
                class="lock"
                :to="link"
                v-if="data.front_container!='tokens'"
            >
              <img :src="getImageBackgroundUrl" :alt="content.name">
            </router-link>
            <div class="lock tokens-lock" v-if="data.front_container=='tokens'" style="text-align: center">
              <div class="lock-message-container">
                <div class="lock-message">
                    <div class="message">
                        {{$t('tokens_post_locked.top_message', {tokens: data.tokens_quantity})}}
                    </div>
                </div>
                <div class="lock-message bottom">
                    <div class="message bottom">
                        {{$t('tokens_post_locked.bottom_message')}}
                    </div>
                </div>
              </div>

                <img :src="getImageBackgroundUrl" :alt="content.name">
            </div>
            <span v-if="content.is_hd" class="hd" >HD</span>
            <span v-if="content.length" class="length">{{pictureLengthFormatted}}</span>
            <BadgePostPremium :post="content"/>
          </div>
        </template>
      
        <template v-else>
          <div class="img"></div>
        </template>
    </article>
</template>
<script>
import BadgePostPremium from "../BadgePostPremium.vue";
import EventBus from "../../../eventbus";

export default {
  components: { BadgePostPremium },
  props: {
    content: {},
    data: {},
    placeholder: {
      type: Boolean,
      required: false,
      default: false,
    },
    model: {
      type: Object,
      required: false,
      default: null,
    },
    imgStyle: {
      type: Object,
      required: false,
      default: null,
    },
    getImageBackgroundUrl: {
      type: String,
      required: false,
      default: null,
    },
    cssVars: {
      type: Object,
      required: false,
      default: null,
    },
    link: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    pictureLengthFormatted() {
      if (this.content.length === null) {
        return null;
      }

      let videoDuration = new Date(this.content.length * 1000)
        .toUTCString()
        .match(/(\d\d:\d\d:\d\d)/)[0];

      if (videoDuration.startsWith("00:")) {
        return videoDuration.substr(3, videoDuration.length);
      } else {
        return videoDuration;
      }
    },
  },
  methods: {
    handleClickOnPost() {
      //If user is not logged, redirect to buy tokens
      if (this.$auth.check()) {
        EventBus.openUnlockPostWithTokens(this.data, this.model);
      } else {
        if (this.data.front_container == "tokens") {
          this.$router.push({ name: "purchase.tokens" });
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../styles/variables";

.picture {
  flex-grow: 0;
  flex-basis: 0;
  transition: width 0.5s ease;
  // max-width: calc(100vw - 20px);
  width: 100%;

  .img {
    background-color: var(--pallete_dark_color);
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin-bottom: 0.5em;
    transition: height 0.5s ease;

    img {
      width: 100%;
      visibility: hidden;
    }

    span.hd {
      position: absolute;
      left: 5px;
      top: 5px;
      padding: 3px;
      font-weight: bold;
      border-radius: 2px;
      background-color: var(--pallete_dark_color);
      color: #ffffff;
    }

    span.length {
      position: absolute;
      right: 5px;
      bottom: 5px;
      padding: 3px;
      border-radius: 2px;
      font-size: 13px;
      background-color: var(--pallete_dark_color);
      color: #ffffff;
    }

    .preview-wrapper {
      opacity: 0;
      transition: opacity 0.3s linear;

      &.active {
        opacity: 1;
      }
    }

    .preview-wrapper.active {
      .preview {
        background-color: var(--pallete_dark_color);
        position: absolute;
        overflow: hidden;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        video {
          /*object-fit: cover;*/
          overflow: hidden;
          min-width: 100%;
          min-height: 100%;
        }
      }

      .preview-unavailable {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.25);
      }
    }
  }

  &.placeholder {
    .img {
      background-color: rgba(128, 128, 128, 0.25);
    }

    .text {
      .description {
        background-color: rgba(128, 128, 128, 0.25);
        height: 1em;
      }

      .name {
        background-color: rgba(128, 128, 128, 0.25);
        height: 1em;
      }
    }
  }

  .locked {
    z-index: 1;

    &:after {
      content: "";
      background: var(--background);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      opacity: 0.4;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: -1;
    }

    img {
      width: 100%;
      visibility: hidden;
      max-height: 95vh;
    }

    .lock {
      display: block;
      width: 100%;
      height: 100%;
      background-image: url("/img/lock-white.png");
      background-size: 75px;
      background-repeat: no-repeat;
      background-position: center;
    }

    .tokens-lock {
      cursor: pointer;
      display: flex;
      justify-content: center;

      .lock-message-container {
        position: absolute;
        width: 100%;
        max-width: 90%;
        top: calc(50% + 3rem);

        // @media (min-width: 375px) {
        //   bottom: calc(50% - 6rem);
        // }

        // @media (min-width: 500px) {
        //   bottom: calc(50% - 7rem);
        // }
  
        hr {
          margin: 0 auto;
          max-width: 75%;
        }
  
        .lock-message {
          display: inline;
          margin: 0 auto;
  
          .message {
            color: #a7a8ab;
            font-size: 0.8rem;
            /*text-shadow: -1px 1px 5px black;*/
  
            @media (min-width: 375px) {
              font-size: 1rem;
            }
  
            @media (min-width: 500px) {
              font-size: 1.5rem;
            }
  
            // &.bottom {
            //   color: #d0d0d0;
            // }
          }
  
          .image img {
            width: 50px;
            height: 50px;
            visibility: visible;
            margin-right: 0.2rem;
          }
        }
      }
    }
  }
}
</style>
